var MuiTabs = {
/* put your new default props here */
};
export default MuiTabs;
//# sourceMappingURL=MuiTabs.js.map